export class DatesService {
    setDateToLastSecondFromDate(date: Date) {
        const _date = new Date(date)
        _date.setHours(0, 0, 0, 0)
        _date.setSeconds(86399, 999)
        return _date
    }

    setDateToLastSecondFromMonth(date: Date) {
        const _date = new Date(date)
        _date.setDate(1)
        _date.setMonth(_date.getMonth() + 1)
        _date.setDate(0)
        _date.setHours(0, 0, 0, 0)
        _date.setSeconds(86399, 999)
        return _date
    }

    setDateStringToLocalMidnight(date: string) {
        const _date = new Date(date)
        _date.setMinutes(_date.getTimezoneOffset())
        _date.setHours(0, 0, 0, 0)
        return _date
    }

    previousMonth() {
        let d = new Date()
        d.setHours(0, 0, 0, 0)
        d.setDate(0) // vai para o último dia do mês anterior
        const to = this.setDateToLastSecondFromDate(d)
        d.setDate(1) // vai para o primeiro dia do mês
        const from = new Date(d)
        return { from, to }
    }

    nextMonth() {
        let from = new Date()
        // vai para o mes seguinte
        from.setDate(1)
        from.setMonth(from.getMonth() + 1)
        from.setHours(0, 0, 0, 0)
        let to = new Date(from)
        to.setMonth(to.getMonth() + 1)
        to.setDate(0)
        to = this.setDateToLastSecondFromDate(to)
        return { from, to }
    }

    currentMonth() {
        let d = new Date()
        d.setHours(0, 0, 0, 0)
        const from = new Date(d.getFullYear(), d.getMonth(), 1)
        const to = this.setDateToLastSecondFromDate(new Date(d.getFullYear(), d.getMonth() + 1, 0))
        return { from, to }
    }

    fullMonth(date: Date) {
        date.setHours(0, 0, 0, 0)
        const from = new Date(date.getFullYear(), date.getMonth(), 1)
        const to = this.setDateToLastSecondFromDate(new Date(date.getFullYear(), date.getMonth() + 1, 0))
        return { from, to }
    }

    yesterday() {
        let d = new Date()
        d.setHours(0, 0, 0, 0)
        d.setDate(d.getDate() - 1)
        const from = new Date(d)
        const to = this.setDateToLastSecondFromDate(d)
        return { from, to }
    }

    today() {
        const from = new Date()
        from.setHours(0, 0, 0, 0)
        const to = this.setDateToLastSecondFromDate(from)
        return { from, to }
    }

    tomorrow() {
        const from = new Date()
        from.setDate(from.getDate() + 1)
        from.setHours(0, 0, 0, 0)
        const to = this.setDateToLastSecondFromDate(from)
        return { from, to }
    }

    weekCurrent() {
        const from = new Date()
        from.setDate(from.getDate() - from.getDay())
        from.setHours(0, 0, 0, 0)
        const to = this.setDateToLastSecondFromDate(from)
        to.setDate(to.getDate() + 6)
        return { from, to }
    }

    weekPrevious() {
        const dates = this.weekCurrent()
        dates.from.setDate(dates.from.getDate() - 7)
        dates.to.setDate(dates.to.getDate() - 7)
        return dates
    }

    weekNext() {
        const dates = this.weekCurrent()
        dates.from.setDate(dates.from.getDate() + 7)
        dates.to.setDate(dates.to.getDate() + 7)
        return dates
    }

    isValid(date: any): boolean {
        const d = new Date(date)
        return d instanceof Date && !isNaN(d.getTime())
    }
}
